import { createAsyncThunk } from '@reduxjs/toolkit';
import ProposalDocsApi from '../../../infrastructure/proposal-document-api';
import { getErrorPayload } from '../../helpers/api-helper';
export const getProposalDocsAsync = createAsyncThunk('proposalDocs/getByProposalId', async (proposalId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await ProposalDocsApi.getProposalDocs(proposalId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const downloadProposalDocumentAsync = createAsyncThunk('proposalDocs/downloadProposalDocs', async (file, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await ProposalDocsApi.downloadProposalDocs(file);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getDocumentByIdDocumentAsync = createAsyncThunk('proposalDocs/getDocById', async (documentId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await ProposalDocsApi.getDocById(documentId);
        return fulfillWithValue(response.data); // Expecting base64 string in response.data
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getDocumentByPathAsync = createAsyncThunk('proposalDocs/getDocByPath', async (documentPath, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await ProposalDocsApi.getDocByPath(documentPath);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
